import {
  calcPressedThickness,
  isThicknessTooThin,
  isGlassStop
} from './prepreg';
import { prepregToString, isOuterCopper } from './material';
import { PREPREG } from '../constants/globals';

export { isOuterCopper } from './material';

export function calcFillRatio(copperThickness, copperFill) {
  return copperThickness * (1 - copperFill);
}

export function getNeighborPrepreg(layers, index) {
  const upLayer = layers && layers[index - 1];
  const downLayer = layers && layers[index + 1];

  if (upLayer && upLayer.type === PREPREG) {
    return upLayer;
  }

  if (downLayer && downLayer.type === PREPREG) {
    return downLayer;
  }

  return undefined;
}

export const validate = (copper, index, layers) => {
    const warnings = [];
    const errors = [];
    const prepreg  = getNeighborPrepreg(layers, index);
    const isOuter = isOuterCopper(copper, layers);

    if (prepreg && !isOuter) {
      const isPrepregUp = prepreg && prepreg.index < index;
      const pressedThickness = prepreg && isPrepregUp
        ? calcPressedThickness(prepreg, prepreg.index, layers, null, copper) 
        : calcPressedThickness(prepreg, prepreg.index, layers, copper, null);
      const glassThickness = prepreg.glassThickness || prepreg._glassThickness;
      const thickness = prepreg.thickness || prepreg._thickness

      const prepregThicknessWarning = prepreg ? isThicknessTooThin(
        thickness,
        pressedThickness,
        glassThickness,
      ) : false;
      const glassStopWarning = prepreg ? isGlassStop(
        pressedThickness,
        glassThickness
      ) : false;

      if (prepregThicknessWarning) {
        warnings.push(`The current configuration will make adjacent prepreg layer (${prepregToString(prepreg._material)}) too thin`);
      }
      if (glassStopWarning) {
        warnings.push(`The current configuration will make adjacent prepreg layer (${prepregToString(prepreg._material)}) to fail to adhere to this copper`);
      }
    }


    return { errors, warnings };
}

export default null;



// WEBPACK FOOTER //
// ./src/lib/copper.js